<configurator-header></configurator-header>
<ion-content scrollY="false"  class="maintenance-service-plan-wrapper">
  <div class="one3d-emi-wrapper">
    <div class="one3d-content-header one3d-custom-border-bottom">
      <h1 class="one3d-content-header-title">{{'AMC.MAINTENANCE_SERVICE_PLAN' | translate}}</h1>
      <button (click)="closeAMC()">
        <span
          ><img
            src="assets/img/icons/one3d-close-icon.svg"
            alt="close page icon"
        /></span>
      </button>
    </div>
  </div>

  <div
    *ngIf="allOptionCategory"
    class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin"
  >
    <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
      <ion-row>
        <ion-col size="6">
          <span class="one3d-summary-item-name">
            <strong> {{'AMC.DURATION' | translate}} </strong>
          </span>
        </ion-col>
        <ion-col size="6">
          <div class="one3d-summary-content-right-col">
            <span class="one3d-summary-item-value">
              {{ allOptionCategory[0]?.product_year }}
            </span>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>

  <div
    *ngIf="allOptionCategory"
    class="one3d-summary-ext-int-wrapper one3d-custom-border-bottom one3d-summary-row-margin"
  >
    <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
      <ion-row>
        <ion-col size="6">
          <span class="one3d-summary-item-name">
            <strong> {{'AMC.MILEAGE' | translate}} </strong>
          </span>
        </ion-col>
        <ion-col size="6">
          <div class="one3d-summary-content-right-col">
            <span class="one3d-summary-item-value">
              {{ allOptionCategory[0]?.optionsList[0].product_kms }}
            </span>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>

  <div
    *ngIf="allOptionCategory"
    class="one3d-summary-ext-int-wrapper one3d-summary-row-margin"
  >
    <div class="one3d-summary-ext-int one3d-summary-ext one3d-mb-0">
      <ion-row>
        <ion-col size="6">
          <span class="one3d-summary-item-name black">
            <strong class="amc-cost-bolder"> {{'AMC.MSP_COST' | translate}} </strong>
          </span>
        </ion-col>
        <ion-col size="6">
          <div class="one3d-summary-content-right-col">
            <span class="one3d-summary-item-name black">
              <strong class="amc-cost-bolder">
                
                {{
                  globalService.currencyFormatter(
                    allOptionCategory[0]?.optionsList[0].warranty_price
                  )
                }}
              </strong>
            </span>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>

  <div class="one3d-discalaimer-section-static">
    <div class="one3d-disclamier-btn-wrapper-static">
      <h4>
        <ion-text>{{'AMC.DISCLAIMER' | translate}}</ion-text>
      </h4>
      <p>
        <ion-text>
          {{'AMC.DISCLAIMER_NOTE' | translate}}
        </ion-text>
      </p>
    </div> 
  </div>

  <div class="one3d-lhs-config-bottom-wrapper one3d-placeAtBottom-summary">
    <ion-row class="one3d-lhs-config-btn-row">
      <ion-col class="ion-no-padding" size="6">
        <ion-button
          (click)="closeAMC()"
          class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
          expand="full"
          fill="solid"
        >
        {{'AMC.SKIP' | translate}}
        </ion-button>
      </ion-col>
      <ion-col class="ion-no-padding" size="6">
        <ion-button
          (click)="addToSummary()"
          class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
          expand="full"
        >
        {{'AMC.ADD_TO_SUMMARY' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
